// Pre-flipa uma imagem horizontalmente (scaleX -1) e devolve um dataURL PNG.
//
// Motivacao: o VirtualBackground do @livekit/track-processors compoe a imagem
// de fundo direto no stream publicado. No consumidor a gente aplica
// `transform: scaleX(-1)` no <video> pra espelhar a pessoa (sensacao natural
// pro outro lado), mas esse CSS flipa TUDO - incluindo o texto/logo baked na
// imagem (nome do medico, CRM, marca). Resultado: cliente via "HelpGlobal"
// e "Dr. Fulano" ao contrario.
//
// Solucao: a gente flipa a imagem UMA VEZ aqui antes de passar pro processor.
// Quando o CSS scaleX(-1) flipa o <video> no consumidor, a pessoa espelha e
// o fundo volta a orientacao natural (porque ja estava pre-flipado). Assim
// so a pessoa aparece espelhada; o texto continua legivel.
//
// Cache por URL evita decodificar a mesma imagem varias vezes quando o medico
// liga/desliga o Fundo ou reconecta. Chave e a URL original; o dataURL flipado
// fica preso em memoria ate reload.
const flipCache = new Map();

export function flipImageHorizontally(url) {
  const cached = flipCache.get(url);
  if (cached) return cached;

  const promise = new Promise((resolve, reject) => {
    const img = new Image();
    // crossOrigin e obrigatorio pra o canvas nao ficar "tainted" ao chamar
    // toDataURL quando a imagem vem de outro origin (ex: CDN do backend).
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth || img.width;
        canvas.height = img.naturalHeight || img.height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('canvas 2d context indisponivel'));
          return;
        }
        ctx.translate(canvas.width, 0);
        ctx.scale(-1, 1);
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      } catch (err) {
        reject(err);
      }
    };
    img.onerror = () => reject(new Error(`falha ao carregar imagem ${url}`));
    img.src = url;
  });

  flipCache.set(url, promise);
  // Remove do cache se falhar pra permitir retry numa proxima tentativa.
  promise.catch(() => flipCache.delete(url));
  return promise;
}
